import { css } from 'styled-components';
import { blenderCss, blenderForeground, } from '@clds/blender';
const intensityByState = {
    selected: {
        normal: 'lg',
        hover: 'xl',
        active: 'xl',
    },
    unselected: {
        normal: 'md',
        hover: 'sm',
        active: 'lg',
    },
};
const modeByTone = {
    surface: 'surfaceSolid',
    solid: 'solidContrast',
    plain: 'plainSolid',
    invert: 'plainInvert',
};
export const toBlenderProps = (selectionState, interactionState, { variant, tone }) => ({
    variant,
    intensity: intensityByState[selectionState][interactionState],
    mode: modeByTone[tone],
});
export const createBlenderMappingForSelectionState = (selectionState) => (props) => css `
    ${blenderCss.populateVariables(toBlenderProps(selectionState, 'normal', props))};
    &:hover {
      ${blenderCss.populateVariables(toBlenderProps(selectionState, 'hover', props))};
    }
    &:active {
      ${blenderCss.populateVariables(toBlenderProps(selectionState, 'active', props))};
    }
  `;
export const buttonBlenderMapping = (props) => createBlenderMappingForSelectionState(props.isSelected ? 'selected' : 'unselected')(props);
export const focusBorderColorBlenderMapping = ({ theme, variant, tone, }) => blenderForeground({
    mode: tone === 'solid' ? 'solidContrast' : 'surfaceSolid',
    variant,
    theme,
});
//# sourceMappingURL=blenderMapping.js.map